import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import StandardButton from "../../standardButton"; // Assicurati che il path sia corretto

export default function DeleteTemplateDialog({
  open,
  handleClose,
  id,
  handleConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{
          backgroundColor: "#191919",
          fontFamily: "Urbanist, sans-serif",
          color: "white",
        }}
      >
        Delete Template
      </DialogTitle>

      <DialogContent
        sx={{
          backgroundColor: "#191919",
          fontFamily: "Urbanist, sans-serif",
        }}
      >
        <DialogContentText
          id="delete-dialog-description"
          sx={{
            color: "white",
            fontFamily: "Urbanist, sans-serif",
          }}
        >
          Are you sure you want to delete the template with ID{" "}
          <strong>{id}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>

      <DialogActions
        sx={{
          backgroundColor: "#191919",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <StandardButton
          onClick={handleClose}
          type="default"
          variant="outlined"
          text="Cancel"
        />
        <StandardButton
          onClick={() => handleConfirm(id)}
          text="Confirm"
          type="error"
          variant="error"
        />
      </DialogActions>
    </Dialog>
  );
}
